/**
 * Proxy country is lowercase ("in" / "us" / "dz").
 * CMS and older UI checks often use uppercase ("IN" / "US" / "DZ").
 * Normalize before comparing so fee/currency logic stays correct.
 */

export function normalizeCountry(country?: string | null): string {
  return country?.toUpperCase() ?? "";
}

/** India (or missing) → INR. Matches ProgramCard / ProgramCard2 behavior. */
export function isIndiaCountry(country?: string | null): boolean {
  const normalized = normalizeCountry(country);
  return !normalized || normalized === "IN";
}

export function isUsCountry(country?: string | null): boolean {
  return normalizeCountry(country) === "US";
}

export function isAfricaCountry(country?: string | null): boolean {
  return normalizeCountry(country) === "DZ";
}

/** Case-insensitive match for route country vs CMS Country field. */
export function matchesCountryCode(
  left?: string | null,
  right?: string | null,
): boolean {
  if (!left || !right) return false;
  return left.toUpperCase() === right.toUpperCase();
}
